/**
 * Resources used in the project
 */
export const LoaderConfig = {
    golden_ball: require("./sprites/golden_ball.png"),
    circle: require("./sprites/circle.png"),
    slot_0: require("./sprites/slot_0.png"),
    slot_1: require("./sprites/slot_1.png"),
    slot_2: require("./sprites/slot_2.png"),
    slot_5: require("./sprites/slot_5.png"),
    slot_10: require("./sprites/slot_10.png")
}